import React from 'react';
import CTA from '../../Content/MarketingSectionContainer/global/CTA';
import CommonUtil from '../../../../utils/commonUtil';

const CategoryListTileSection = ({ component, state }) => {
  const container_id = `category-tile-${CommonUtil.generateSeoFriendlyUrl(component?.title)}`;

  return (
    <div id='category-Grid'>
      <style>{`
          #${container_id} img.thumbnail-image {
             height: 174px;
          }
          @media (min-width: 768px) {
            #${container_id} img.thumbnail-image {
              height: 300px;
            }
          }
      `}</style>
      <div
        id={container_id}
        className='section-wrapper row text-center mkt-section'
      >
        <div className='col-xs-12'>
          <div className='row'>
            <div className='col-xs-12'>
              <div className='section-title'>
                {component?.title && <h5>{component?.title}</h5>}
                {component?.sub_title && (
                  <p
                    className={
                      state?.user?.data?.result?.isLoggedIn
                        ? 'logged-user-wap'
                        : ''
                    }
                  >
                    {component?.sub_title}
                  </p>
                )}
              </div>
              {component?.description && (
                <p className='section5-text'>{component?.description}</p>
              )}
            </div>
          </div>

          <div className='category-grid-container'>
            {component?.categories?.map((category, idx) => {
              const cta = category?.cta || {};
              const buttonTitle =
                cta?.title || category?.category_name || 'Ver más';

              const get_width_class = (layout) => layout || '100';

              return (
                <div
                  className={`dw-${get_width_class(category?.layout?.screen_width_desktop)}
                  mw-${get_width_class(category?.layout?.screen_width_mobile)}
                  category-wrapper ${idx % 3 == 0 ? 'thumbnail-wrapper' : ''}`}
                  key={idx}
                >
                  <CTA
                    cta={{ ...cta, title: buttonTitle }}
                    isLink='true'
                    variant='primary'
                  >
                    <div
                      className='category-thumbnail'
                      style={{ cursor: 'pointer' }}
                    >
                      <picture>
                        {/* Desktop */}
                        <source
                          media='(min-width: 1025px)'
                          srcSet={category?.placeholder_image?.desktop}
                        />

                        {/* Tablet */}
                        <source
                          media='(min-width: 768px)'
                          srcSet={category?.placeholder_image?.tablet}
                        />

                        {/* Mobile fallback */}
                        <img
                          src={category?.placeholder_image?.mobile}
                          alt={category?.category_name}
                          style={{
                            width: '100%',
                            objectFit: 'cover',
                            borderRadius: '4px 4px 0 0',
                          }}
                          className='thumbnail-image'
                          loading='lazy'
                        />
                      </picture>
                      <div
                        className='caption text-left eventName-icon-div'
                        style={{ padding: '10px 15px' }}
                      >
                        <span
                          className='icon eventName-icon-svg'
                          dangerouslySetInnerHTML={{
                            __html: category?.label_icon.content,
                          }}
                        ></span>
                        <span className='category-name'>
                          {category?.category_name}
                        </span>
                        <div className='arrow pull-right'>
                          <img
                            src='/assets/common/images/svgs/chevron_right.svg'
                            alt='Navigate to category'
                          />
                        </div>
                      </div>
                    </div>
                  </CTA>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryListTileSection;
